import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../services/dataService.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

    static componentName = 'MenuComponent';
    temp: any;
    menu: any;

    @Input()menuId: String;

    constructor(
        private dataService: DataService,
    ) {}

    getStructure(): void {
        this.dataService.getStructure(this.menuId)
            .subscribe(res => this.convertMenuObject(res));
    }

    convertMenuObject(res): void {
        this.temp = Object.keys(res).map(function(resNamedIndex) {
            return res[resNamedIndex];
        });

        this.menu = this.temp;
    }

    closeSidebar() {
        const wrapEl = document.querySelectorAll('div.site-wrap');
        const headerEl = document.querySelectorAll('header.site-header');
        const menuEl = document.querySelectorAll('ul.menu');
        const bodyEl = document.querySelectorAll('body');
        wrapEl[0].classList.remove('sidebar');
        headerEl[0].classList.remove('move-left');
        menuEl[0].classList.remove('open');
        bodyEl[0].classList.remove('menu-open');
    }

    ngOnInit() {
        this.getStructure();

        // Show/hide full menu/side menu trigger
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', this.menuSwitch);
        }
    }

    menuSwitch = () => {
        const fullMenu = document.querySelector('.menu-full');
        const smallMenu = document.querySelector('.site-menu');

        if (window.scrollY >= 200) {
            fullMenu.classList.add('hide');
            smallMenu.classList.remove('hide');
        } else {
            smallMenu.classList.add('hide');
            fullMenu.classList.remove('hide');
        }
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/menu/menu.component.ts